var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.987305H513V342.991H0V0.987305Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.987305H513V114.985H0V0.987305Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.982H513V342.98H0V228.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.721 97.6377V182.94C129.721 231.464 193.111 246.331 193.111 246.331C193.111 246.331 256.5 231.462 256.5 182.94V97.6377H129.721Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.938 112.507H230.284V82.7684L215.414 90.2029L193.109 67.8994L170.807 90.2029L155.938 82.7684V112.507ZM241.631 194.816L193.306 146.491L144.98 194.816L160.752 210.587L193.306 178.033L225.859 210.587L241.631 194.816Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.631 149.68H219.083C220.397 147.424 221.088 144.859 221.088 142.248C221.088 134.036 214.43 127.379 206.219 127.379C200.545 127.379 195.617 130.557 193.11 135.23C190.603 130.558 185.675 127.379 180.002 127.379C171.791 127.379 165.133 134.036 165.133 142.248C165.133 144.959 165.87 147.493 167.138 149.68H144.98C144.98 157.892 152.133 164.549 160.344 164.549H159.849C159.849 172.761 166.506 179.418 174.718 179.418C174.718 186.69 179.94 192.73 186.836 194.023L175.119 220.475C180.894 222.825 187.07 224.031 193.304 224.026C199.538 224.03 205.714 222.825 211.488 220.475L199.771 194.023C206.668 192.73 211.889 186.69 211.889 179.418C220.101 179.418 226.758 172.761 226.758 164.549H226.263C234.478 164.549 241.631 157.892 241.631 149.68Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.989258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/RS.e21703790bfecf316d1d900eefdfd29e.svg";
export { ForwardRef as ReactComponent };